import type { TranslationMessages } from '../types';

export const recipes: TranslationMessages = {
  name: 'Quản lý công thức',
  add: 'Thêm công thức',
  edit: 'Chỉnh sửa công thức',
  deleteAction: 'Xóa công thức',
  create: 'Tạo công thức',
  list: 'Công thức',
  search: 'Tìm kiếm công thức...',
  ingredients: 'Nguyên liệu',
  status: 'Trạng thái',
  cost: 'Chi phí',
  valid: 'Hợp lệ',
  invalid: 'Không hợp lệ',
  empty: 'Không tìm thấy công thức',
  basicInformation: 'Thông tin cơ bản',
  placeholders: {
    enterName: 'Nhập tên công thức',
    selectCategory: 'Chọn danh mục',
    enterDescription: 'Nhập mô tả công thức',
    enterImageId: 'Nhập ID hình ảnh (tùy chọn)',
    selectIngredient: 'Chọn nguyên liệu',
    enterAmount: '0',
  },
  delete: {
    title: 'Xóa công thức',
    confirm:
      'Bạn có chắc chắn muốn xóa "%{name}"? Hành động này không thể hoàn tác.',
  },
  fields: {
    name: 'Tên',
    description: 'Mô tả',
    imageId: 'Hình ảnh',
    productCategoryId: 'Danh mục sản phẩm',
    ingredients: 'Nguyên liệu',
    amount: 'Số lượng',
  },
  ingredient: {
    quickCreate: 'Tạo nhanh nguyên liệu',
  },
  validation: {
    title: 'Chi tiết xác thực công thức',
    description: 'Tại sao "%{name}" không hợp lệ:',
    details: 'Xem chi tiết xác thực',
    noErrors: 'Không tìm thấy lỗi xác thực.',
    errors: 'Lỗi xác thực:',
    missingMappings: 'Thiếu liên kết tồn kho:',
    missingMappingItem:
      'Nguyên liệu "%{ingredientName}" chưa có liên kết tồn kho. Vui lòng liên kết nguyên liệu này với một mục tồn kho.',
    errorNoMapping:
      'Nguyên liệu "%{ingredientName}" chưa có liên kết tồn kho',
    fixInstructions:
      'Để khắc phục các vấn đề này, bạn có thể tự động tạo mục tồn kho cho các nguyên liệu còn thiếu, hoặc tạo thủ công trong trang quản lý tồn kho.',
    goToMappings: 'Đi đến Quản lý Tồn kho',
    autoFix: {
      button: 'Tự động khắc phục liên kết thiếu',
      processing: 'Đang xử lý...',
      warning:
        'Lưu ý: Tự động khắc phục tạo các mục tồn kho cơ bản với cài đặt mặc định. Thông tin gói hàng (số lượng mục, kích thước, trọng lượng, thể tích) phải được quản lý cửa hàng xem xét và cấu hình thủ công.',
      success:
        'Đã tạo thành công %{count} mục tồn kho. Vui lòng xem xét và cấu hình chi tiết gói hàng thủ công.',
      error: 'Không thể tự động khắc phục: %{message}',
      partialError:
        'Đã tạo %{success} mục, nhưng %{error} mục thất bại: %{details}',
      noWarehouse:
        'Không thể tự động khắc phục: Không tìm thấy kho. Vui lòng tạo kho trước.',
      noCategory:
        'Không thể tự động khắc phục: Không tìm thấy danh mục tồn kho. Vui lòng tạo danh mục tồn kho trước.',
    },
  },
};
